import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import * as TYPES from '../constants/actionTypes'
import * as API from '../constants/api'

export const studentQuizById = createAsyncThunk(
  TYPES.STUDENT_QUIZ_BY_ID,
  async (params: PayloadCreatorParams<`${typeof API.STUDENT_QUIZ_BY_ID}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.studentQuizById(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const studentQuizSave = createAsyncThunk(
  TYPES.STUDENT_QUIZ_SAVE,
  async (params: PayloadCreatorParams<`${typeof API.STUDENT_QUIZ_SAVE}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.studentQuizSave(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const studentQuizList = createAsyncThunk(
  TYPES.STUDENT_QUIZ_ALL,
  async (params: PayloadCreatorParams<`${typeof API.STUDENT_QUIZ}`, 'get'> | undefined, { rejectWithValue }) => {
    try {
      const response = await api.studentQuizList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

// export const studentQuizSelect = createAsyncThunk(
//   TYPES.STUDENT_QUIZ_SELECT,
//   async (params: PayloadCreatorParams<`${typeof API.STUDENT_QUIZ_SELECT}`, 'get'>, { rejectWithValue }) => {
//     try {
//       const response = await api.studentQuizSelect(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
//       params?.onFulfilled && params.onFulfilled(response.data)
//       return response.data
//     } catch (e) {
//       const error = toastError(e)
//       params?.onRejected && params.onRejected({ error })
//       return rejectWithValue(error)
//     } finally {
//       params?.onSettled && params.onSettled()
//     }
//   }
// )

export const studentQuizAll = createAsyncThunk(
  TYPES.STUDENT_QUIZ_ALL,
  async (params: PayloadCreatorParams<`${typeof API.STUDENT_QUIZ_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.studentQuizAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const studentQuizSubmit = createAsyncThunk(
  TYPES.STUDENT_QUIZ_SUBMIT,
  async (params: PayloadCreatorParams<`${typeof API.STUDENT_QUIZ_SUBMIT}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.studentQuizSubmit(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const studentQuizStart = createAsyncThunk(
  TYPES.STUDENT_QUIZ_START,
  async (params: PayloadCreatorParams<`${typeof API.STUDENT_QUIZ_START}`, 'post'>, { rejectWithValue }) => {
    try {
      const response = await api.studentQuizStart(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

// export const studentQuizSubmitManual = createAsyncThunk(
//   TYPES.STUDENT_QUIZ_SUBMIT_MANUAL,
//   async (params: PayloadCreatorParams<`${typeof API.STUDENT_QUIZ_SUBMIT_MANUAL}`, 'post'>, { rejectWithValue }) => {
//     try {
//       const response = await api.studentQuizSubmitManual(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
//       params?.onFulfilled && params.onFulfilled(response.data)
//       return response.data
//     } catch (e) {
//       const error = toastError(e)
//       params?.onRejected && params.onRejected({ error })
//       return rejectWithValue(error)
//     } finally {
//       params?.onSettled && params.onSettled()
//     }
//   }
// )

export const studentQuizByIdClear = createAction(`${TYPES.STUDENT_QUIZ_BY_ID}/clear`)

export const studentQuizListClear = createAction(`${TYPES.STUDENT_QUIZ_LIST}/clear`)

export const studentQuizSelectClear = createAction(`${TYPES.STUDENT_QUIZ_SELECT}/clear`)

export const studentQuizAllClear = createAction(`${TYPES.STUDENT_QUIZ_ALL}/clear`)
